module.exports = __webpack_public_path__ + "img/patient-info-up-new.166559f5.svg";